var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.907,
    x2: 404.713,
    xlinkHref: "#lg1",
    y1: 69.213,
    y2: 356.019
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.442,
    x2: 259.282,
    y1: 16.586,
    y2: 136.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.241,
    x2: 46.622,
    xlinkHref: "#lg2",
    y1: 58.926,
    y2: 69.883
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.372,
    x2: 86.753,
    y1: 58.926,
    y2: 69.883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.358,
    x2: 142.441,
    y1: 53.948,
    y2: 88.031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 343.483,
    y2: 442.478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2428,
    stopColor: "#93cef6",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#6abfec",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    stopColor: "#51b5e5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.603,
    x2: 238.42,
    y1: 462.397,
    y2: 336.214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8fc5e9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56a4c8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2d8db1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147ea2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.599,
    x2: 314.407,
    xlinkHref: "#lg2",
    y1: 313.184,
    y2: 427.991
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.801,
    x2: 249.679,
    y1: 449.775,
    y2: 364.653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63950",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0467,
    stopColor: "#e4354b",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#d31822",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7991,
    stopColor: "#c90709",
    stopOpacity: 0.799
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.846,
    x2: 278.207,
    xlinkHref: "#lg1",
    y1: 342.821,
    y2: 393.182
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.588 390.309h-471.176c-10.721 0-19.412-8.691-19.412-19.412v-329.182c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412v329.182c0 10.721-8.691 19.412-19.412 19.412z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 100.878h-510v-59.163c0-10.721 8.691-19.412 19.412-19.412h471.176c10.721 0 19.412 8.691 19.412 19.412z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.853 77.328h-10.229c-5.867 0-10.623-4.756-10.623-10.623v-10.229c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c0 5.867-4.756 10.623-10.623 10.623z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.984 77.328h-10.23c-5.867 0-10.623-4.756-10.623-10.623v-10.229c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c.001 5.867-4.755 10.623-10.622 10.623z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.115 77.328h-10.229c-5.867 0-10.623-4.756-10.623-10.623v-10.229c0-5.867 4.756-10.623 10.623-10.623h10.229c5.867 0 10.623 4.756 10.623 10.623v10.229c0 5.867-4.756 10.623-10.623 10.623z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 300.799v70.099c0 10.721 8.691 19.412 19.412 19.412h471.176c10.721 0 19.412-8.691 19.412-19.412v-70.099z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b5dbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.113 307.684h-104.397c-7.252 0-13.131-5.879-13.131-13.131v-126.207c0-7.252 5.879-13.131 13.131-13.131h104.397c7.252 0 13.131 5.879 13.131 13.131v126.206c.001 7.252-5.878 13.132-13.131 13.132z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.513 193.215h-71.598c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h71.598c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.915 193.215h-125c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h125c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.317 250.449h71.598c5.247 0 9.5-4.253 9.5-9.5v-19c0-5.247-4.253-9.5-9.5-9.5h-71.598c-5.247 0-9.5 4.253-9.5 9.5v19c0 5.247 4.253 9.5 9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.915 250.449h125c5.247 0 9.5-4.253 9.5-9.5v-19c0-5.247-4.253-9.5-9.5-9.5h-125c-5.247 0-9.5 4.253-9.5 9.5v19c0 5.247 4.253 9.5 9.5 9.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m286.513 307.684h-71.598c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h71.598c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.915 307.684h-125c-5.247 0-9.5-4.253-9.5-9.5v-19c0-5.247 4.253-9.5 9.5-9.5h125c5.247 0 9.5 4.253 9.5 9.5v19c0 5.246-4.253 9.5-9.5 9.5z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m340.807 285.98c-21.668-22.503-52.101-34.506-85.807-34.506-65.784 0-117.111 51.327-117.111 117.111 0 7.42.68 14.681 1.979 21.724h305.268z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 368.585,
    fill: "url(#SVGID_8_)",
    r: 119.112
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.73 305.551-34.73 34.73-34.731-34.731c-9.029-9.028-20.664-8.027-29.693 1.001-9.029 9.029-8.028 21.665 1.001 30.694l33.73 33.73-33.73 32.729c-9.029 9.029-11.03 22.666-2.001 31.694l51.618 51.497c4.531.523 9.136.801 13.806.801 65.784 0 119.112-53.328 119.112-119.112 0-3.656-.174-7.271-.496-10.843l-53.192-53.192c-9.029-9.027-21.665-8.026-30.694 1.002z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.695 369.975 32.729-32.729c9.029-9.029 9.029-23.666 0-32.695-9.029-9.028-23.666-9.028-32.695 0l-32.729 32.729-32.729-32.729c-9.029-9.028-23.666-9.028-32.695 0-9.029 9.029-9.029 23.666 0 32.695l32.729 32.729-32.729 32.729c-9.029 9.029-9.029 23.666 0 32.695 4.514 4.514 10.431 6.771 16.347 6.771s11.833-2.257 16.347-6.771l32.73-32.729 32.729 32.729c4.514 4.514 10.431 6.771 16.348 6.771s11.833-2.257 16.347-6.771c9.029-9.029 9.029-23.666 0-32.695z",
    fill: "url(#SVGID_10_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.715a6324.svg";
export { ForwardRef as ReactComponent };